import type { Transformer } from "@/Common/Models/Domain/Transformer";
import type { BotStageApi } from "../../../Models/Api/FlexoBot";
import type { BotStage, BotQuestion } from "../../../Models/Domain/FlexoBot";
import { BotStageType } from "../../../Models/Domain/FlexoBot";

import { hasValue } from "@/Utils/Objects";
import FlexoApiConnector from "@/Services/TherapyApi/Flexo";
import BotQuestionApiToBotQuestionTransformer from "@/Modules/Transformers/Chat/Bot/BotQuestionApiToBotQuestion";

class BotStageApiToBotStageTransformer implements Transformer<BotStageApi, Promise<BotStage>> {
  constructor(
    private readonly flexoApiConnector = new FlexoApiConnector(),
    private readonly botQuestionApiToBotQuestionTransformer = new BotQuestionApiToBotQuestionTransformer()
  ) {}

  public async transform(botStageApi: BotStageApi): Promise<BotStage> {
    let question: BotQuestion | null = null;

    if (botStageApi.type === BotStageType.QUESTION && hasValue(botStageApi.question_uuid)) {
      const botQuestionApiResponse = await this.flexoApiConnector.getQuestionById(botStageApi.question_uuid);

      question = await this.botQuestionApiToBotQuestionTransformer.transform(botQuestionApiResponse);
    }

    const botStage: BotStage = {
      question,
      id: botStageApi.uuid,
      type: botStageApi.type,
    };

    return botStage;
  }
}

export default BotStageApiToBotStageTransformer;
